
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-cannot-create-account-header\">{{#t}}Cannot create account{{/t}}</h1>\n  </header>\n\n  <section class=\"cannot-create-account-content\">\n    <p>\n      {{#unsafeTranslate}}You must meet certain age requirements to create a Firefox&nbsp;Account.{{/unsafeTranslate}}\n    </p>\n    <p class=\"links\">\n      <a class=\"ftc\" href=\"http://www.ftc.gov/news-events/media-resources/protecting-consumer-privacy/kids-privacy-coppa\" {{#isSync}} target=\"_blank\"{{/isSync}}>{{#t}}Learn more{{/t}}</a>\n    </p>\n\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/cannot_create_account.mustache
// module id = 215
// module chunks = app